import { useTranslation } from 'react-i18next'
import type { ContentLocale } from '@/data/public-catalog'
import { traceabilityProducts, type TraceabilityProductKey } from '@/data/product-pages/traceability'
import { ProductMedia } from './ProductMedia'

export function EsapoctBody({ language }: { language: ContentLocale }) {
  const { t } = useTranslation('common')
  const italian = (key: string) => t(`productPage.esapoct.${key}`, { lng: 'it' })
  const paragraphs = t('productPage.esapoct.paragraphs', { lng: 'it', returnObjects: true }) as string[]
  const modules = t('productPage.esapoct.modules', { lng: 'it', returnObjects: true }) as Array<{ title: string; description: string }>
  return <section className="shell-container product-section traceability-body esapoct-body" aria-labelledby="esapoct-body-title">
    <div className="esapoct-layout" lang={language === 'en' ? 'it' : undefined}>
      <div className="product-copy esapoct-copy">
        <h2 id="esapoct-body-title">{italian('bodyTitle')}</h2>
        {paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
        <section className="esapoct-governance" aria-labelledby="esapoct-governance-title">
          <h2 id="esapoct-governance-title">{italian('governanceTitle')}</h2>
          <ul>{modules.map(module => <li key={module.title}><h3>{module.title}</h3><p>{module.description}</p></li>)}</ul>
        </section>
      </div>
      <ProductMedia path={traceabilityProducts['prd-esapoct-gestione-poct'].secondaryMedia} altKey="productPage.esapoct.softwareAlt" className="traceability-screen esapoct-screen" />
    </div>
  </section>
}

export function SamtraceBody({ language }: { language: ContentLocale }) {
  const { t } = useTranslation('common')
  const paragraphs = t('productPage.samtrace.paragraphs', { lng: 'it', returnObjects: true }) as string[]
  return <section className="shell-container product-section traceability-body samtrace-body" aria-labelledby="samtrace-body-title">
    <div className="samtrace-layout" lang={language === 'en' ? 'it' : undefined}>
      <div className="product-copy samtrace-copy">
        <h2 id="samtrace-body-title">{t('productPage.samtrace.bodyTitle', { lng: 'it' })}</h2>
        <div className="samtrace-flow">
          {paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
        </div>
      </div>
      <ProductMedia path={traceabilityProducts['prd-samtrace-sistema-esamed-per-la-tracciabilita-delle-provette'].secondaryMedia} altKey="productPage.samtrace.softwareAlt" className="traceability-screen samtrace-screen" />
    </div>
  </section>
}

export function TraceabilityBody({ productKey, language }: { productKey: TraceabilityProductKey; language: ContentLocale }) {
  return productKey === 'esapoct' ? <EsapoctBody language={language} /> : <SamtraceBody language={language} />
}
